var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotiCheckOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotiCheckOut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5972223,4.47098762 C17.8569736,4.74720768 17.9999998,5.11620935 17.9999998,5.50976391 C18.0002171,5.90355457 17.8571909,6.27255624 17.5974397,6.54901238 C16.3334619,7.89328335 12.9656079,11.02 9,11.02 C5.03417473,11.02 1.66653806,7.89351943 0.402777679,6.54924847 C0.142809083,6.27279232 -0.000217117654,5.90379065 2.47392082e-07,5.51 C2.47392082e-07,5.11620935 0.143026448,4.74744376 0.402777679,4.4712237 C1.66653806,3.12695274 5.03439209,8.8817842e-15 9,8.8817842e-15 C12.9653905,8.8817842e-15 16.3332446,3.12671665 17.5972223,4.47098762 Z M9,2.20739963 C7.32324603,2.20739963 5.95928036,3.68883628 5.95928036,5.51 C5.95928036,7.33116372 7.32324603,8.81260037 9,8.81260037 C10.676754,8.81260037 12.0407196,7.33116372 12.0407196,5.51 C12.0407196,3.68883628 10.6765366,2.20739963 9,2.20739963 Z M9,7.78161489 C7.84687843,7.78161489 6.90851352,6.76243369 6.90851352,5.51 C6.90851352,4.25756631 7.84666106,3.23838511 9,3.23838511 C10.1533389,3.23838511 11.0914865,4.25733022 11.0914865,5.51 C11.0914865,6.76266978 10.1531216,7.78161489 9,7.78161489 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotiCheckOut"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#F85454",
    cx: 13,
    cy: 13,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(4.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotiCheckOut);
export default __webpack_public_path__ + "static/media/icNotiCheckOut.2b14db9aad109deacbf86a91e91c3cea.svg";
export { ForwardRef as ReactComponent };